import { getVueTemplate, getUrlParameter } from "../../_imports/utils/utils.common";

import skillsSelector from "./skills-selector.vue";
import { leave, smoothEnter, rollUp, rollDown } from "./utils/transitions.vue";

export default {
    name: "search-by-skills-light",
    template: getVueTemplate("search-by-skills-light"),
    components: {
        skillsSelector,
    },
    data() {
        return {
            searchValue: "",
            isVisible: true,
            skills: [],
        };
    },
    mixins: [leave, smoothEnter, rollUp, rollDown],
    methods: {
        initSbSLight() {
            if (this.isVisible) {
                const urlSearch = window.location.search;

                if (urlSearch) {
                    let searchSkillsValues = getUrlParameter("skills");

                    if(searchSkillsValues) {
                        searchSkillsValues = searchSkillsValues.split("_");
                        searchSkillsValues.pop();

                        this.skills = decodeURIComponent(searchSkillsValues).split(',');

                        this.searchValue = decodeURIComponent(getUrlParameter("searchvalue"));
                    }
                }
            }
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.$el.classList.add("component-is-mounted");
            this.initSbSLight();
        });
    },
};
